// src/services/StripeConnectService.js

import { base_url } from "../utils/constante";

// ⚠️ Mets ici la même URL de base que dans CreateurService.js / BilletterieService.js
const API_URL = base_url

const token = () => localStorage.getItem("token") || sessionStorage.getItem("token");

const appel = async (chemin, methode = "GET", corps = null) => {
    const res = await fetch(`${API_URL}${chemin}`, {
        method: methode,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token()}`,
        },
        body: corps ? JSON.stringify(corps) : null,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || "Erreur Stripe");
    return data;
};

/** État du compte de paiement du créateur. */
export const getStatutStripe = () => appel("createur/stripe/status");

/** Lance (ou reprend) le formulaire Stripe. `retour` = page où revenir après. */
export const demarrerOnboardingStripe = async (retour = "/EspaceClient/billetterie") => {
    const { url } = await appel("createur/stripe/onboarding", "POST", { retour });
    window.location.href = url;
};

/** Ouvre le tableau de bord Stripe Express (versements, RIB…). */
export const ouvrirDashboardStripe = async () => {
    const { url } = await appel("createur/stripe/dashboard", "POST");
    window.open(url, "_blank", "noopener");
};